import { isZendeskEnvProd } from "@/env/config";

const membersZendeskUrls = {
  ["健康診断"]: {
    prod: "https://help-top.mykenpo.com/hc/ja/articles/31937162595097-2024%E5%B9%B4%E5%BA%A6%E5%81%A5%E5%BA%B7%E8%A8%BA%E6%96%AD%E3%81%AE%E3%81%8A%E7%9F%A5%E3%82%89%E3%81%9B-%E5%8A%A0%E5%85%A5%E8%80%85%E3%81%AE%E7%9A%86%E6%A7%98%E3%81%B8",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/9656006452495-2024%E5%B9%B4%E5%BA%A6%E5%81%A5%E5%BA%B7%E8%A8%BA%E6%96%AD%E3%81%AE%E3%81%8A%E7%9F%A5%E3%82%89%E3%81%9B-%E5%8A%A0%E5%85%A5%E8%80%85%E3%81%AE%E7%9A%86%E6%A7%98%E3%81%B8",
  },
  ["マイナ保険証"]: {
    prod: "https://help-top.mykenpo.com/hc/ja/articles/31992008579737-%E3%83%9E%E3%82%A4%E3%83%8A%E4%BF%9D%E9%99%BA%E8%A8%BC%E7%A7%BB%E8%A1%8C%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/9667002046095-%E3%83%9E%E3%82%A4%E3%83%8A%E4%BF%9D%E9%99%BA%E8%A8%BC%E7%A7%BB%E8%A1%8C%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6",
  },
  ["ヘルプ"]: {
    prod: "https://help-members.mykenpo.com/hc/ja",
    dev: "https://help-members.dev.mykenpo.com/hc/ja",
  },
  ["お問い合わせフォーム"]: {
    prod: "https://help-top.mykenpo.com/hc/ja/requests/new",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/requests/new",
  },
  ["利用規約"]: {
    prod: "https://help-top.mykenpo.com/hc/ja/articles/31992897832089-mykenpo%E3%81%AE%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/9667194269199-mykenpo%E3%81%AE%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6",
  },
  ["個人情報保護方針"]: {
    prod: "https://help-top.mykenpo.com/hc/ja/articles/31992990011545-%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E4%BF%9D%E8%AD%B7%E6%96%B9%E9%87%9D",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/9667284055951-%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E4%BF%9D%E8%AD%B7%E6%96%B9%E9%87%9D",
  },
  ["公告"]: {
    prod: "https://help-top.mykenpo.com/hc/ja/categories/30218072859801",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/sections/9524369956367-%E5%85%AC%E5%91%8A",
  },
} as const satisfies Record<string, { prod: string; dev: string }>;

export const getMembersZendeskUrl = (key: keyof typeof membersZendeskUrls) => {
  return membersZendeskUrls[key][isZendeskEnvProd() ? "prod" : "dev"];
};

export const getForgotAuthCodeUrl = () => {
  const url = {
    prod: "https://help-top.mykenpo.com/hc/ja/articles/31996310254745-mykenpo%E6%8B%9B%E5%BE%85%E3%82%B3%E3%83%BC%E3%83%89%E3%81%AE%E5%86%8D%E7%99%BA%E8%A1%8C%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/9667786525839-mykenpo%E6%8B%9B%E5%BE%85%E3%82%B3%E3%83%BC%E3%83%89%E3%81%AE%E5%86%8D%E7%99%BA%E8%A1%8C%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6",
  };
  return url[isZendeskEnvProd() ? "prod" : "dev"];
};

const changeNameUrl = {
  dev: "https://help-members.dev.mykenpo.com/hc/ja/articles/9656857268367-%E5%9F%BA%E6%9C%AC%E6%83%85%E5%A0%B1-%E6%B0%8F%E5%90%8D-%E4%BD%8F%E6%89%80-%E3%81%8C%E5%A4%89%E3%82%8F%E3%82%8B%E3%81%A8%E3%81%8D",
  prod: "https://help-members.mykenpo.com/hc/ja/articles/31941482221081-%E5%9F%BA%E6%9C%AC%E6%83%85%E5%A0%B1-%E6%B0%8F%E5%90%8D-%E4%BD%8F%E6%89%80-%E3%81%8C%E5%A4%89%E3%82%8F%E3%82%8B%E3%81%A8%E3%81%8D",
};

const changeAddressUrl = changeNameUrl;

const deleteAccountUrl = {
  dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/9833985290383-%E5%8A%A0%E5%85%A5%E8%80%85%E3%83%A6%E3%83%BC%E3%82%B6%E3%83%BC%E3%81%AE%E3%82%A2%E3%82%AB%E3%82%A6%E3%83%B3%E3%83%88%E5%89%8A%E9%99%A4%E3%82%92%E3%81%94%E5%B8%8C%E6%9C%9B%E3%81%AE%E6%96%B9",
  prod: "https://help-top.mykenpo.com/hc/ja/articles/32911320400025-%E5%8A%A0%E5%85%A5%E8%80%85%E3%83%A6%E3%83%BC%E3%82%B6%E3%83%BC%E3%81%AE%E3%82%A2%E3%82%AB%E3%82%A6%E3%83%B3%E3%83%88%E5%89%8A%E9%99%A4%E3%82%92%E3%81%94%E5%B8%8C%E6%9C%9B%E3%81%AE%E6%96%B9",
};

const membersSettingZendeskUrls = {
  dev: {
    insured: {
      changeName: changeNameUrl.dev,
      changeAddress: changeAddressUrl.dev,
      manageDependents:
        "https://help-members.dev.mykenpo.com/hc/ja/articles/9657331373455-%E5%AE%B6%E6%97%8F-%E8%A2%AB%E6%89%B6%E9%A4%8A%E8%80%85-%E3%81%AE%E4%BA%BA%E6%95%B0%E3%81%8C%E5%A4%89%E3%82%8F%E3%82%8B%E3%81%A8%E3%81%8D",
      deleteAccount: deleteAccountUrl.dev,
    },
    optionalAndContinued: {
      changeName: changeNameUrl.dev,
      changeAddress: changeAddressUrl.dev,
      manageDependents:
        "https://help-members.dev.mykenpo.com/hc/ja/articles/9657391603599-%E4%BB%BB%E6%84%8F%E7%B6%99%E7%B6%9A%E8%A2%AB%E4%BF%9D%E9%99%BA%E8%80%85%E3%81%AE%E5%AE%B6%E6%97%8F-%E8%A2%AB%E6%89%B6%E9%A4%8A%E8%80%85-%E3%81%AE%E4%BA%BA%E6%95%B0%E3%81%8C%E5%A4%89%E3%82%8F%E3%82%8B%E3%81%A8%E3%81%8D",
      deleteAccount: deleteAccountUrl.dev,
    },
    dependent: {
      changeName: changeNameUrl.dev,
      changeAddress: changeAddressUrl.dev,
      manageDependents: undefined,
      deleteAccount: deleteAccountUrl.dev,
    },
    lostEligibility: {
      changeName: changeNameUrl.dev,
      changeAddress: changeAddressUrl.dev,
      manageDependents: undefined,
      deleteAccount: deleteAccountUrl.dev,
    },
  },
  prod: {
    insured: {
      changeName: changeNameUrl.prod,
      changeAddress: changeAddressUrl.prod,
      manageDependents:
        "https://help-members.mykenpo.com/hc/ja/articles/31943857426969-%E5%AE%B6%E6%97%8F-%E8%A2%AB%E6%89%B6%E9%A4%8A%E8%80%85-%E3%81%AE%E4%BA%BA%E6%95%B0%E3%81%8C%E5%A4%89%E3%82%8F%E3%82%8B%E3%81%A8%E3%81%8D",
      deleteAccount: deleteAccountUrl.prod,
    },
    optionalAndContinued: {
      changeName: changeNameUrl.prod,
      changeAddress: changeAddressUrl.prod,
      manageDependents:
        "https://help-members.mykenpo.com/hc/ja/articles/31944263098393-%E4%BB%BB%E6%84%8F%E7%B6%99%E7%B6%9A%E8%A2%AB%E4%BF%9D%E9%99%BA%E8%80%85%E3%81%AE%E5%AE%B6%E6%97%8F-%E8%A2%AB%E6%89%B6%E9%A4%8A%E8%80%85-%E3%81%AE%E4%BA%BA%E6%95%B0%E3%81%8C%E5%A4%89%E3%82%8F%E3%81%A3%E3%81%9F%E3%81%A8%E3%81%8D",
      deleteAccount: deleteAccountUrl.prod,
    },
    dependent: {
      changeName: changeNameUrl.prod,
      changeAddress: changeAddressUrl.prod,
      manageDependents: undefined,
      deleteAccount: deleteAccountUrl.prod,
    },
    lostEligibility: {
      changeName: changeNameUrl.prod,
      changeAddress: changeAddressUrl.prod,
      manageDependents: undefined,
      deleteAccount: deleteAccountUrl.prod,
    },
  },
} as const;

export const getMembersSettingZendeskUrls = () => {
  return membersSettingZendeskUrls[isZendeskEnvProd() ? "prod" : "dev"];
};

// 高額療養費の口座情報登録についてのヘルプページURL
// NOTE: dev環境用URLが存在しないため、prod URLのみ定義
const highCostMedicalExpenseHelpUrl = {
  prod: "https://help-members.mykenpo.com/hc/ja/articles/32620716633113-%E8%A2%AB%E4%BF%9D%E9%99%BA%E8%80%85%E6%8C%AF%E8%BE%BC%E5%8F%A3%E5%BA%A7%E7%99%BB%E9%8C%B2-%E5%A4%89%E6%9B%B4-%E5%B1%8A%E3%81%AE%E7%94%B3%E8%AB%8B%E6%96%B9%E6%B3%95",
  dev: "https://help-members.mykenpo.com/hc/ja/articles/32620716633113-%E8%A2%AB%E4%BF%9D%E9%99%BA%E8%80%85%E6%8C%AF%E8%BE%BC%E5%8F%A3%E5%BA%A7%E7%99%BB%E9%8C%B2-%E5%A4%89%E6%9B%B4-%E5%B1%8A%E3%81%AE%E7%94%B3%E8%AB%8B%E6%96%B9%E6%B3%95",
} as const;

export const getHighCostMedicalExpenseHelpUrl = () => {
  return highCostMedicalExpenseHelpUrl[isZendeskEnvProd() ? "prod" : "dev"];
};

// 任意継続被保険者の資格喪失証明書交付申請書のヘルプページURL
const optionalContinuedCertificateUrl = {
  prod: "https://help-members.mykenpo.com/hc/ja/articles/31943320872729",
  dev: "https://help-members.dev.mykenpo.com/hc/ja/articles/9657197368975",
} as const;

export const getOptionalContinuedCertificateUrl = () => {
  return optionalContinuedCertificateUrl[isZendeskEnvProd() ? "prod" : "dev"];
};
